import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
    CreateEmployeePerformanceInput,
    CreateHrPerformanceInput,
    CreateManagerPerformanceInput,
    IManagerListRes,
    IPerformanceDatas,
    IPerformanceManager
} from './interface';

const API_URI = `${environment.apiBaseUrl}/performance-management`;

@Injectable({
    providedIn: 'root'
})
export class PerformanceManagementService {
    http: HttpClient = inject(HttpClient);

    getAllPerformanceRequestManager(managerId: string) {
        return this.http.get<IPerformanceDatas[]>(`${API_URI}?managerId=${managerId}`);
    }

    getPerformanceByManager(input: { id: string; managerFormId?: string }) {
        return this.http.get<IManagerListRes>(
            `${API_URI}/${input.id}?managerFormId=${input.managerFormId}`
        );
    }

    getAllPerformanceManagerHistry(input: { managerId: string; userId: string }) {
        return this.http.get<IPerformanceManager[]>(
            `${API_URI}/manager-history/${input.managerId}?userId=${input.userId}`
        );
    }
    getSingleManagerPerformance(input: { id: string; employeeFormId?: string }) {
        return this.http.get<IManagerListRes>(
            `${API_URI}/manager/single/${input.id}?employeeFormId=${input.employeeFormId}`
        );
    }

    getAllPerformanceEmployeeByManager(managerId: string) {
        return this.http.get<IPerformanceManager[]>(
            `${API_URI}/manager-employees-history/${managerId}`
        );
    }

    getSingleEmployeePerformanceByManager(id: string) {
        return this.http.get<IManagerListRes>(`${API_URI}/employee/single/${id}`);
    }

    sendHrPerformanceData(input: CreateHrPerformanceInput) {
        return this.http.post(`${API_URI}`, input);
    }

    sendManagerPerformanceData(input: CreateManagerPerformanceInput) {
        return this.http.post(`${API_URI}/manager`, input);
    }

    updateManagerPerformanceData(input: CreateManagerPerformanceInput) {
        return this.http.patch<IManagerListRes>(`${API_URI}/manager`, input);
    }

    createEmployeePerformanceData(input: CreateEmployeePerformanceInput) {
        return this.http.post(`${API_URI}/employee`, input);
    }

    uploadSignature(input: { employeeName: string; signatureUrl: string }) {
        return this.http.post<{ employeeName: string; signatureUrl: string }>(
            `${API_URI}/upload-signature`,
            input
        );
    }
}
